module.exports = __webpack_public_path__ + "static/media/photo23.4a5a8977.jpg";